import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ProleisObject} from "proleis-rest-client";

@Component({
  selector: 'p4m-active-tracking',
  templateUrl: './active-tracking.component.html',
  styleUrls: ['./active-tracking.component.scss']
})
export class ActiveTrackingComponent {
  @Input()
  tracking: ProleisObject;

  @Output()
  machineWorkingTimeChanged = new EventEmitter<number>();

  onMachineWorkingTimeChanged(event: any) {
    this.machineWorkingTimeChanged.emit(Number(event.target.value));
  }
}
